import type { SVGProps } from "react";

export default function SolarListLinear(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><g fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5"><path d="M20 7L4 7"/><path d="M15 12L4 12"/><path d="M9 17H4"/></g></svg>
  );
}
